export default {"src":"/_next/static/media/website.e8232e94.svg","height":30,"width":30};